import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/graduateCeremony'
// import index from '@/components/undergradCeremony'
import index from '@/components/allCeremonies'
// import index from '@/components/watchBoth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/commencement/live',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js